export const categories = [
  "Blazer Set",
  "Coat",
  "Pant & Trousers",
  "T-shirt & Shirts",
  "Belt & Accessories",
  "Sweater & Inners",
  "Jacket & Outer",
  "Slipper & Shoes",
  "Cap & Beanie",
];
